<template>
  <div>
    <button class="transparent-btn mr-3" @click="edit">
      修改
    </button>
    <button class="transparent-btn" @click="del">
      刪除
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState({
      user: 'user',
    }),
  },
  methods: {
    edit() {
      const { id } = this.params.data;
      // 呼叫父親method!
      this.params.context.componentParent.tempProductOpen(false, id);
    },

    del() {
      let vm = this;
      this.$fire({
        title: '確定刪除?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: '停留在此頁',
        cancelButtonText: '取消',
      }).then(result => {
        if (result.value === true) {
          const selRows = [this.params.data];
          const { url: apiDel } = new this.$adminUrl(
            false,
            this.user.uuid,
            this.user.apiPath,
            this.params.data.id,
          );
          this.axios
            .delete(apiDel)
            .then(res => {
              this.$fire({
                title: `${res}`,
                type: 'success',
                timer: 3000,
              });
            })
            .then(() => {
              vm.params.context.componentParent.gridOptions.api.updateRowData({
                remove: selRows,
              });
            });
          return;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
